import React from "react";
import classNames from "classnames";

import { Skeleton } from "@common/skeleton";
import { ListToggleArrow } from "@common/listToggleArrow";
import { RecordList } from "./recordList";
import { Props } from "./types";
import { List } from "./list";
import styles from "./styles.scss";

function Allocation({ isLoadingTs }: Props) {
  return (
    <div className={styles.allocation}>
      {!isLoadingTs ? (
        <div className={styles.main}>
          <div className={styles.resource}>
            <div className={styles.iconBox}>
              <ListToggleArrow isOpen={false} />
            </div>
            <div className={styles.row}>
              <Skeleton className={styles.avatar} />
              <div className={styles.col}>
                <Skeleton className={styles.name} />
              </div>
            </div>
          </div>
          <div className={styles.recordList}>
            <RecordList type="resource" />
          </div>
        </div>
      ) : (
        <List />
      )}
    </div>
  );
}

export { Allocation };
